import { debounce } from 'lodash';
import { useCallback } from 'react';

export const useDebounce: typeof debounce = (...args) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedFn = useCallback(debounce(...args), []);
  return debouncedFn;
};